import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { supabase } from '../lib/supabase';

interface Props {
  adminName: string;
  onLogout: () => void;
}

export function Layout({ adminName, onLogout }: Props) {
  const [connected, setConnected] = useState(false);
  const [realtimeActive, setRealtimeActive] = useState(false);

  useEffect(() => {
    supabase.from('bars').select('id', { count: 'exact', head: true })
      .then(({ error }) => setConnected(!error));

    // Global realtime channel for connection indicator
    const channel = supabase.channel('admin-global-realtime')
      .on('postgres_changes', { event: '*', schema: 'public', table: 'bars' }, () => {})
      .on('postgres_changes', { event: '*', schema: 'public', table: 'matches' }, () => {})
      .on('postgres_changes', { event: '*', schema: 'public', table: 'diffusions' }, () => {})
      .subscribe((status) => {
        setRealtimeActive(status === 'SUBSCRIBED');
      });

    return () => { supabase.removeChannel(channel); };
  }, []);

  return (
    <div className="app-layout">
      <Sidebar adminName={adminName} onLogout={onLogout} />
      <div className="app-main">
        <Header adminName={adminName} connected={connected} realtimeActive={realtimeActive} />
        <div className="app-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
